import { mapState, mapActions, mapMutations } from 'vuex'
import RegionOrdersTable from './components/region-orders-table/region-orders-table.vue'
import CourierRegionInfo from './components/courier-region-info/courier-region-info.vue'
import StatPanel from '@/components/stat-panel/stat-panel.vue'
import MainMap from '@/components/main-map/main-map.vue'
import OrdersStatistics from '@/components/orders-statistics/orders-statistics.vue'
import escPressPagesWithMap from '@/pages/mixins/escPressPagesWithMap'
import debounce from 'lodash.debounce'

export default {
  name: 'RegionOrders',
  components: {
    RegionOrdersTable,
    CourierRegionInfo,
    StatPanel,
    MainMap,
    OrdersStatistics
  },
  /**
   * escPressPagesWithMap - переход назад по esc
   */
  mixins: [ escPressPagesWithMap ],
  static() {
    return {
      refreshLoading: false,
      /**
       * для сценария когда размер страницы меньше высоты окна,
       * пока идет загрузка всех данных в refreshAllData может этот момент уйти в условии
       * watch regionOrdersFilters, поэтому продолжим логику в "ручную"
       * в finaly refreshAllData
       */
      nextOffset: false,

      fetchFirstTime: true
    }
  },
  data() {
    return {
      shiftStats: null
    }
  },
  computed: {
    ...mapState({
      pageLoading: state => state.pageLoader.loading,
      selectedCity: state => state.manufactures.selectedCity,
      selectedAreas: state => state.manufactures.selectedAreas,
      regionOrders: state => state.regionOrders.regionOrders,
      ordersByStatusesFilter: state => {
        const result = { ...state.regionOrders.regionOrdersByStatuses }
        delete result.total
        return result
      },
      regionOrdersLoading: state => state.regionOrders.regionOrdersLoading,
      ordersStatsLoading: state => state.regionOrders.ordersStatsLoading,
      regionOrderPayments: state => state.regionOrders.regionOrderPayments,
      regionOrdersFilters: state => state.regionOrders.regionOrdersFilters,
      editedRouteTask: state => state.routeTasks.editedRouteTask
    })
  },
  mounted() {
    this.$bus.$on('refresh-managers-info', this.refreshAllDataDebounce)
    if (this.selectedCity) {
      /**
       * !!! Не debounce
       */
      this.refreshAllData(true)
    }

    /**
     * иначе полагаемся на watch
     */
    
  },
  beforeDestroy() {
    this.$bus.$off('refresh-managers-info', this.refreshAllDataDebounce)
    this.setRegionOrdersFilters({
      ...this.regionOrdersFilters,
      offset: 0
    })
    this.setRegionOrders({
      ...this.regionOrders,
      data: [],
      count: 0
    })
    this.setEditedRouteTask([])
    this.setEditedRouteTaskInfo(null)
  },
  methods: {
    ...mapActions({
      getRegionOrders: 'regionOrders/getRegionOrders',
      getShiftStats: 'regionOrders/getShiftStats',
      cancelRegionOrders: 'regionOrders/cancelRegionOrders',
      cancelShiftStats: 'regionOrders/cancelShiftStats'
    }),
    ...mapMutations({
      setRegionOrders: 'regionOrders/SET_REGION_ORDERS',
      setRegionOrdersFilters: 'regionOrders/SET_REGION_ORDERS_FILTERS',
      setEditedRouteTask: 'routeTasks/SET_EDITED_ROUTE_TASK',
      setEditedRouteTaskInfo: 'routeTasks/SET_EDITED_ROUTE_TASK_INFO'
    }),
    async refreshAllData(expressIncluded = false) {
      this.fetchFirstTime = false
      const cancelPromises = [
        this.cancelRegionOrders(),
        this.cancelShiftStats()
      ]
      await Promise.all(cancelPromises)
      this.refreshLoading = true
      this.setRegionOrdersFilters({
        ...this.regionOrdersFilters,
        offset: 0
      })
      const dataPromises = [
        this.getRegionOrders(),
        this.setShiftStats()
      ]
      if (expressIncluded) {
        dataPromises.push(this.$refs['orders-statistics'].refreshExpressAnalysis())
      }
      try {
        await Promise.all(dataPromises)
      } finally {
        this.refreshLoading = false
        if (this.nextOffset) {
          this.nextOffset = false
          this.getRegionOrders()
        }
      }
    },
    refreshAllDataDebounce: debounce(function(...args) {
      this.refreshAllData(...args)
    }, 500),
    onSetStatusFilter(statusFilter) {
      this.setRegionOrdersFilters({
        ...this.regionOrdersFilters,
        offset: 0,
        statuses: statusFilter
      })
    },
    async setShiftStats() {
      this.shiftStats = await this.getShiftStats()
    }
  },
  watch: {
    regionOrdersFilters(newFilters, oldFilters) {
      if (this.refreshLoading) {
        if (newFilters.offset > oldFilters.offset) {
          this.nextOffset = true
        }
        return
      }
      this.getRegionOrders()
    },
    selectedCity() {
      /**
       * при выходе на стартовый экран город может обнулиться
       */
      if (this.selectedCity) {
        this.refreshAllDataDebounce(true)
      }
    },
    selectedAreas() {
      /**
       * при выходе на стартовый экран город и производство могут обнулиться
       */
      if (this.selectedCity) {
        this.refreshAllDataDebounce(true)
      }
    }
  }
}